var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-tabs',{attrs:{"pills":"","card":"","vertical":_vm.iswin ? true : false}},[_c('b-tab',{attrs:{"title":"研究项目","active":""}},[_c('Project')],1),_c('b-tab',{attrs:{"title":"论文发表"}},[_c('Paper')],1)],1)],1),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMo),expression:"isMo"}]},[_c('b-col')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }